import { addCostItem, deleteCostTemplateDetail, findCostItemPage } from '@/services/product'
import { apiData2Table } from '@/utils/data'
import { Button, message, Result } from 'antd'
import { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import { SLowcodeList } from 'shj-components'

const FeeTemplateConfigTable = (props: {
  chooseItem: any
  activeTabKey: string
  outsideListRef: any
}) => {
  const { chooseItem, activeTabKey, outsideListRef } = props
  // 是否所有必填项都已填写
  const allReady = chooseItem.categoryType && chooseItem.quoteType
  const { id: costTemplateId } = useParams() || {}
  const listRef = useRef<any>()
  const [loading, setLoading] = useState(false)
  const [clickBtnId, setClickBtnId] = useState('')
  // 获取列表
  const fetchList = async (params: any) => {
    return new Promise((resolve, reject) => {
      try {
        findCostItemPage({
          params: {
            pageId: params.current,
            pageSize: params.pageSize,
            costTemplateId,
          },
          data: {
            itemNameKey: chooseItem.itemName,
            costType: activeTabKey,
            parentId: '0',
            searchFlag: true,
            enabled: true,
          },
        }).then((res: any) => {
          resolve(apiData2Table(res))
        })
      } catch (error) {
        reject({ success: false })
      }
    })
  }

  // 加入费用项
  const addItem = (record: any) => {
    setLoading(true)
    setClickBtnId(record.id)
    addCostItem({
      costTemplateId,
      quoteType: chooseItem.quoteType,
      categoryType: chooseItem.categoryType,
      itemName: record.itemName,
      priceItemId: record.id,
    })
      .then(() => {
        message.success('加入成功')
        listRef.current.reload()
        outsideListRef.current.reload()
      })
      .finally(() => {
        setLoading(false)
      })
  }

  // 取消加入费用项
  const cancelItem = (record: any) => {
    setLoading(true)
    setClickBtnId(record.id)
    const costMatchItem = record.costTemplateDtlList.find(
      item =>
        item.categoryType === chooseItem.categoryType && item.quoteType === chooseItem.quoteType
    )
    deleteCostTemplateDetail(costMatchItem.id)
      .then(() => {
        message.success('取消加入成功')
        listRef.current.reload()
        outsideListRef.current.reload()
      })
      .finally(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    // 如果所有必填项都已填写，则重新加载列表
    if (allReady) {
      listRef.current.reload()
    }
  }, [allReady, chooseItem, outsideListRef])

  const config = {
    rowSelection: false,
    fieldControl: false,
    tableType: 'antd',
    columns: [
      {
        title: '名称',
        dataIndex: 'itemName',
      },
      {
        title: '操作',
        render: 'actionTool',
        width: 150,
      },
    ],
  }

  const extension = {
    request: { fetchList },
    customRender: {
      actionTool: (_, record: any) => {
        const isItemAlreadyAdded = record.costTemplateDtlList?.some(
          item =>
            item.categoryType === chooseItem.categoryType && item.quoteType === chooseItem.quoteType
        )
        const buttonText = isItemAlreadyAdded ? '取消加入' : '加入'
        const handleClick = isItemAlreadyAdded ? cancelItem : addItem
        return (
          <Button
            type="link"
            onClick={() => handleClick(record)}
            loading={loading && clickBtnId === record.id}
          >
            {buttonText}
          </Button>
        )
      },
    },
  }

  return (
    <>
      {allReady ? (
        <SLowcodeList
          searchMode={'group'}
          config={config}
          ref={listRef}
          {...extension}
          scroll={{ y: 'calc(100vh - 490px)' }}
        />
      ) : (
        <Result status="warning" subTitle="请先填写必填项" style={{ marginTop: 100 }} />
      )}
    </>
  )
}

export default FeeTemplateConfigTable
